function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Suppress tabbing keystrokes to keep tab trap from escaping the target element
 * @param {boolean} on
 * @param {Element} self
 * @param {Element | DocumentFragment} [root]
 */
var supressKeys = function supressKeys(on, self, root) {
  if (!self || !root) {
    return;
  }

  var startElement;
  var endElement;
  var focusableElements = self.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

  if (focusableElements && focusableElements.length >= 1) {
    startElement = focusableElements[0];
    endElement = focusableElements[focusableElements.length - 1];
  }
  /**
   * @param {KeyboardEvent} event
   */


  var handleEvent = function handleEvent(event) {
    var activeElement = root.getRootNode().activeElement || document.activeElement;

    if (event.shiftKey && event.key === 'Tab') {
      if (activeElement === startElement) {
        event.preventDefault();
        endElement.focus();
      }
    } else if (event.key === 'Tab') {
      if (activeElement === endElement) {
        event.preventDefault();
        startElement.focus();
      }
    }
  };

  if (on) {
    self.addEventListener('keydown', handleEvent, true);
  } else {
    self.removeEventListener('keydown', handleEvent, true);
  }
};
/**
 * @param {Element} elem
 * @param {string} attr
 * @param {string} cache
 * @param {string} disablerValue
 */


var injectTabTrap = function injectTabTrap(elem, attr, cache, disablerValue) {
  var currentIndex = elem.getAttribute(attr) || '';
  elem.setAttribute(attr, disablerValue);
  elem.setAttribute(cache, currentIndex);
};
/**
 * @param {Element} elem
 * @param {string} attr
 * @param {string} cache
 */


var ejectTabTrap = function ejectTabTrap(elem, attr, cache) {
  var priorIndex = elem.getAttribute(cache) || '';
  priorIndex ? elem.setAttribute(attr, priorIndex) : elem.removeAttribute(attr);
  elem.removeAttribute(cache);
};
/**
 * @param {boolean} on - Turn the trapping on or off.
 * @param {Element} self - The element that you don't want to block.
 * @param {Element|ShadowRoot} [root=document.body] - The root element to search for elements to block.
 */


export var tabTrap = function tabTrap(on, self) {
  var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : typeof document !== 'undefined' && document.body;

  /**
   * Future Optimisation: Replace the querySelectorAll loop below with
   * `on ? topElem.setAttribute('inert', '') : topElem.removeAttribute('inert');`
   * Inert is a new proposed attribute to help modal trapping.
   * Or... use these polyfills
   * - https://github.com/GoogleChrome/inert-polyfill (limited IE support, uses events)
   * - https://github.com/WICG/inert (performance tradeoff using MutationObserver)
   */

  /**
   * @param {Element} topElem
   */
  var applyTabTrap = function applyTabTrap(topElem) {
    [].concat(_toConsumableArray(topElem.querySelectorAll('*')), [topElem]).forEach(function (elem) {
      if (elem.hasAttribute('aria-live')) {
        return;
      } // IE11 svg doesn't honor tabindex, so need to flip focusable instead.


      var isSvg = elem.tagName.toLowerCase() === 'svg';
      var attr = isSvg ? 'focusable' : 'tabindex';
      var cache = "data-prior-".concat(attr);
      var disablerValue = isSvg ? 'false' : '-1';
      var elemWasTouched = elem.hasAttribute(cache);

      if (on) {
        if (!elemWasTouched) {
          injectTabTrap(elem, attr, cache, disablerValue);
          injectTabTrap(elem, 'aria-hidden', 'data-prior-hidden', 'true');
        }
      } else {
        if (elemWasTouched) {
          ejectTabTrap(elem, attr, cache);
          ejectTabTrap(elem, 'aria-hidden', 'data-prior-hidden');
        }
      }
    });
  };

  _toConsumableArray(root.children).forEach(function (topElem) {
    if (topElem !== self) {
      applyTabTrap(topElem);
    }
  });
  /**
   * Block elements outside the root when root isn't document.body.
   * This is needed to prevent focus from escaping outside of the root when keyboard shorcuts are used.
   */


  if (root !== document.body) {
    _toConsumableArray(document.body.children).forEach(function (topElem) {
      if (!(topElem.contains(root) || topElem.contains(root.host))) {
        applyTabTrap(topElem);
      }
    });
  }

  supressKeys(on, self, root);
};
export default tabTrap;